module.exports = __webpack_public_path__ + "static/media/Compras2.67ffa0c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCompras/Compras2.png
// module id = 2068
// module chunks = 0